<template>
  <div >
    <div class="mt-4 flex items-center space-x-4">
      <div class="relative flex-1 flex items-center justify-between">
        <div>
          <p class="font-bold leading-none">Taxable Component</p>
          <p class="text-gray-600 text-sm">The taxable amount for this pension</p>
        </div>
        <div>
          <m-badge>{{ taxablePercent | percent }}</m-badge>
        </div>
        <div
          v-if="isPartTwoMini"
          class="absolute right-1 mt-16 cursor-pointer"
          @click="handleSwitch"
        >
          <svg
            class="w-4 h-4"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <!-- eslint-disable max-len -->
            <path
              d="M5 12a1 1 0 102 0V6.414l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L5 6.414V12zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"
            ></path>
            <!-- eslint-enable max-len -->
          </svg>
        </div>
      </div>
      <div class="flex-1">
        <m-input-dollar
          id="taxable-amount"
          type="dollar"
          class="w-full"
          state="disabled"
          :value="taxableAmount"
        ></m-input-dollar>
      </div>
    </div>
    <div class="mt-4 flex items-center space-x-4">
      <div class="flex-1 flex items-center justify-between">
        <div>
          <p class="font-bold leading-none">Tax Free Component</p>
          <p class="text-gray-600 text-sm">The tax free amount for this pension</p>
        </div>
        <div>
          <m-badge>{{ (1 - taxablePercent) | percent }}</m-badge>
        </div>
      </div>
      <div class="flex-1">
        <m-input-dollar
          id="non-taxable-amount"
          type="dollar"
          class="w-full"
          state="disabled"
          :value="nonTaxableAmount"
        ></m-input-dollar>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash';
import toolkit from '@/app/mixins/toolkit/item';

export default {
  name: 'pension-schedule-tax-components',
  mixins: [toolkit],
  computed: {
    isFixedAmount() {
      return this.getItem.setup.howMuch === 'A fixed amount';
    },
    isPartTwoMini() {
      return this.getItem.setup.part === 'PART_2_MINI';
    },
    accumulation() {
      return this.getItem.accumulation;
    },
    pensions() {
      return this.getItem.pensions;
    },
    activePension() {
      return this.getItem.activePension;
    },
    amount() {
      return this.isFixedAmount
        ? this.pensions[this.activePension].fixedAmount
        : this.pensions[this.activePension].amount;
    },
    taxablePercent() {
      return this.accumulation.components.taxable.percent;
    },
    taxableAmount() {
      return (this.amount - this.nonTaxableAmount).toFixed(2);
    },
    nonTaxableAmount() {
      // eslint-disable-next-line max-len
      return (this.amount * (this.accumulation.components.nonTaxable.value / this.accumulation.amount)).toFixed(2);
    },
  },
  methods: {
    handleSwitch() {
      const accumulation = {
        amount: 0,
        components: {
          taxable: {
            value: 0,
            percent: this.taxablePercent === 1 ? 0 : 1,
          },
          nonTaxable: {
            value: 0,
            percent: this.taxablePercent === 1 ? 1 : 0,
          },
        },
        status: this.accumulation.status,
      };

      return this.setItem({ accumulation });
    },
  },
};
</script>

<style></style>
